<template>
    <md-content id="dashboard-panel-container" class="" ref="dashboard-panel-container">
        <info-panel></info-panel>
        <div class="dashboard-charts-container">
            <dashboard :blocks="blocks"></dashboard>
        </div>
    </md-content>
</template>

<script>

import InfoPanel from "@/components/OADashboard/InfoPanel.vue"
import Dashboard from "@/components/Dashboard.vue";
export default {
    data: () => ({
        dashVisible: true
    }),
    computed: {
        blocks(){
            return this.$store.getters['dashboard/getBlocks'];
        },
    },
    components: {
        InfoPanel,
        Dashboard,
    },
}
</script>

<style scoped lang="scss">
    #dashboard-panel-container {
        display: flex;
        flex-direction: column;
        .dashboard-charts-container {
            overflow: auto;
        }


    }
@media screen and (min-width: 1024px) {
    #dashboard-panel-container {
        max-height: 90vh;
    }
}

</style>